import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import ContractModalContext from '../../../../../../ContractModal/context/ContractModalContext';
import SendOnboardingLinkModal from '../../../../../../ContractModal/Modals/SendOnboardingLinkModal';
import ContractModalFooter from '../../../../../../ContractModal/ContractModalFooter';

const LeadModalContractActionButtons = ({ showSendLinkOption }) => {
  const [showSendOnboardingLinkModal, setShowSendOnboardingLinkModal] = useState(false);

  const { isReadOnly, onboardingLinkRecipient, onboardingLink } = useContext(ContractModalContext);

  return (
    <>
      {!isReadOnly && (
        <ContractModalFooter
          onSendLink={() => setShowSendOnboardingLinkModal(true)}
          showSendLinkOption={showSendLinkOption}
          isWithoutFooterPadding
        />
      )}
      {showSendOnboardingLinkModal && !!onboardingLinkRecipient && (
        <SendOnboardingLinkModal
          recipient={onboardingLinkRecipient}
          onboardingLink={onboardingLink}
          showModal={showSendOnboardingLinkModal}
          onClose={() => setShowSendOnboardingLinkModal(false)}
        />
      )}
    </>
  );
};

LeadModalContractActionButtons.propTypes = {
  showSendLinkOption: PropTypes.bool.isRequired,
};

export default compose(
  observer,
)(LeadModalContractActionButtons);
